import { observer } from 'mobx-react';
import React from 'react';

import type Template from 'stores/Template';

import DrawerButton from '../DrawerButton';

export interface UpdateTemplateButtonProps {
  template: Template;
}

function UpdateTemplateButton({ template }: UpdateTemplateButtonProps) {
  const showUpdateTemplateModal = () => {
    const templates = template.parent;
    if (!templates) return;
    templates.uploadManager.beginUpdate(template.data.name);
    templates.uploadManager.modalVisible = true;
  };

  return (
    <DrawerButton disabled={template.loading} onClick={showUpdateTemplateModal}>
      Update
    </DrawerButton>
  );
}

export default observer(UpdateTemplateButton);
